import React from 'react'
import { Box, Typography, Grid, Button } from '@mui/material'
import { ImageTextCard } from '../cards/imageTextCard'
import turfing from '../../_content/fenceturf.webp'
import fencing from '../../_content/fencing13.webp'
import paving from '../../_content/readgarden.webp'
import driveway from '../../_content/driveway7.webp' 
import { useNavigate } from 'react-router-dom'

const Services = () => {
  const navigate = useNavigate()
  
    const navigateLink = (link) => {
      navigate(link)
      window.scrollTo(0, 0)
    }

  return (
    <Box
      sx={{
        py: 6,
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          width: '90%',
          mx: 'auto',
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: '#f5f7f6',
            textAlign: 'center',
            mb: 5,
            letterSpacing: '0.5px',
          }}
        >
          Our Services
        </Typography>

        <Grid container spacing={{ xs: 2, md: 3 }}>
          <Grid item xs={12} sm={6} md={3}>
            <ImageTextCard
              media={paving}
              header="Paving"
              link="/services/paving"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <ImageTextCard
              media={turfing}
              header="Turfing"
              link="/services/turfing"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <ImageTextCard
              media={fencing}
              header="Fencing"
              link="/services/fencing"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <ImageTextCard
              media={driveway}
              header="Driveways"
              link="/services/driveways"
            />
          </Grid>
        </Grid>

        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            size="large"
            onClick={() => navigateLink('/services')}
            sx={{
              backgroundColor: '#8FAA30',
              color: '#015f44',
              px: 5,
              py: 1.5,
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '8px',
              transition: 'all 0.25s ease',
              '&:hover': {
                backgroundColor: '#9fc23c',
                transform: 'translateY(-2px)',
              },
            }}
          >
            View All Services
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Services